import type { DashboardDecorationKind } from "../types/dashboard";

export const BINDABLE_FIELDS_BY_KIND: Record<DashboardDecorationKind, string[]> = {
  heading: ["title"],
  label: ["title"],
  panel: ["title", "content"],
  text: ["content"],
  table: ["title"],
  image: ["title", "style.imageUrl"],
  divider: [],
  spacer: [],
};

export function bindableFieldsForKind(kind: DashboardDecorationKind): string[] {
  return BINDABLE_FIELDS_BY_KIND[kind] ?? [];
}

export function bindingFieldLabelKey(fieldPath: string): string {
  return `dashboard.binding.field.${fieldPath}`;
}
